module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/chicken-2.4e061534.png";